import { decode } from 'js-base64';
import { NotificationCard } from '../../components/Card';
import { Avatar, Button, Center, Flex, Icon, Text } from '@chakra-ui/react';
import { useMarkAsReadMutation } from '@/store/query/notification';
import { NotificationLink } from '../../components/NotificationLink';
import { NotificationTime } from '../../components/Time';
import { Edit05 } from '@kula-ai/icons-core';

const ReviewRequest = ({ notification = {}, onClose = () => {} }) => {
  const [markAsRead] = useMarkAsReadMutation();
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));

  const {
    review_name,
    job_name,
    job_url,
    job_stage_name,
    contact_id,
    contact_name,
    application_url,
    reminder,
    requested_by = {},
  } = data;

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="46px" h="46px" borderRadius="full" bg="ats-tertiary">
        <Icon as={Edit05} color="ats-primary" />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start">
        <Text>
          <Text as="span" fontSize="sm">
            {reminder ? `Don't forget y` : `Y`}ou have a review request for
            candidate
          </Text>
          <Text as="span" size="sm-semi-bold">
            <NotificationLink
              to={`/candidates/${contact_id}`}
              label={contact_name}
              onClose={onClose}
              notification={notification}
            />
          </Text>
          <Text as="span" fontSize="sm">
            {' '}
            on Job{' '}
          </Text>
          <Text as="span" size="sm-semi-bold">
            <NotificationLink
              to={job_url}
              label={job_name}
              onClose={onClose}
              notification={notification}
            />
          </Text>
          <Text as="span" fontSize="sm">
            {' '}
            for{' '}
          </Text>
          <Text as="span" size="sm-semi-bold">
            {review_name}
          </Text>
        </Text>
        <Text size="sm-semi-bold">Details</Text>
        <Flex
          border="1px solid"
          borderColor="border-color"
          borderRadius="sm"
          p="14px"
          flexDir="column"
          gap="6px"
          mt="-6px"
        >
          <Text size="sm-semi-bold">Candidate</Text>
          <Flex mb="6px" gap="6px">
            <Avatar
              size="2xs"
              borderRadius="4px"
              className="avatar-xs"
              name={contact_name}
            />
            <Text fontSize="sm" wordBreak="break-word">
              {contact_name}
            </Text>
          </Flex>
          <Text size="sm-semi-bold">Job</Text>
          <Text fontSize="sm" mb="6px">
            {job_name}
          </Text>
          <Text size="sm-semi-bold">Stage</Text>
          <Text fontSize="sm" mb="6px">
            {job_stage_name}
          </Text>
          <Text size="sm-semi-bold">Activity</Text>
          <Text fontSize="sm" mb="6px">
            {review_name}
          </Text>
          {requested_by?.name && (
            <>
              <Text size="sm-semi-bold" mb="4px">
                Requested by
              </Text>
              <Flex mb="6px" gap="6px" align="center">
                <Avatar
                  size="2xs"
                  borderRadius="4px"
                  className="avatar-xs"
                  name={requested_by?.name}
                />
                <Text fontSize="sm">{requested_by?.name}</Text>
              </Flex>
            </>
          )}
        </Flex>
        <NotificationTime notification={notification} />
        <Button
          w="fit-content"
          variant="ats-primary"
          borderRadius="8px"
          onClick={() => {
            markAsRead({ id: notification?.id });
            window.open(application_url, '_self'); // todo check for review url
            onClose();
          }}
          maxH="34px"
          data-test-id="submit-review-button"
        >
          Submit review
        </Button>
      </Flex>
    </Flex>
  );
};

export const ReviewRequestNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ReviewRequest notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
